"use strict";
function baseUnary(func) {
    return function (value) {
        return func(value);
    };
}
module.exports = baseUnary;
//# sourceMappingURL=_baseUnary.js.map